/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthCodeExchangeReqVo
 */
export interface OAuthCodeExchangeReqVo {
    /**
     * 回调 URL 携带的一次性登录码
     * 一次性登录码
     * @type {string}
     * @memberof OAuthCodeExchangeReqVo
     */
    loginCode: string;
}

/**
 * Check if a given object implements the OAuthCodeExchangeReqVo interface.
 */
export function instanceOfOAuthCodeExchangeReqVo(value: object): value is OAuthCodeExchangeReqVo {
    if (!('loginCode' in value) || value['loginCode'] === undefined) return false;
    return true;
}

export function OAuthCodeExchangeReqVoFromJSON(json: any): OAuthCodeExchangeReqVo {
    return OAuthCodeExchangeReqVoFromJSONTyped(json, false);
}

export function OAuthCodeExchangeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthCodeExchangeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'loginCode': json['loginCode'],
    };
}

export function OAuthCodeExchangeReqVoToJSON(json: any): OAuthCodeExchangeReqVo {
    return OAuthCodeExchangeReqVoToJSONTyped(json, false);
}

export function OAuthCodeExchangeReqVoToJSONTyped(value?: OAuthCodeExchangeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loginCode': value['loginCode'],
    };
}

